import { useProductStore } from "src/stores/product";
import PConfirmDialog from "src/components/PConfirmDialog.vue";
import { useQuasar } from "quasar";

export function useApproveProduct({ closeForm, formData, permissions }) {
  const $q = useQuasar();

  const isApproveLoading = ref(false);

  const { putApproveProduct } = useProductStore();

  const approveToggleStatus = async (dialog) => {
    dialog.hide();

    isApproveLoading.value = true;

    await putApproveProduct(unref(formData));

    isApproveLoading.value = false;

    closeForm(true);
  };

  const confirmApproveToggleStatus = () => {
    const { name } = unref(formData);
    let title = "Approve";
    const dialog = $q.dialog({
      component: PConfirmDialog,
      componentProps: {
        title: `${title} Product`,
        text: `Are you sure you want to ${title} ${name}?`,
        isFooterVisible: true,
        submittable: true,
        cancelLabel: "Cancel",
        closable: true,
        onConfirm: () => approveToggleStatus(dialog),
      },
    });
  };

  const approveButton = computed(() => {
    return {
      label: "Approve",
      type: "button",
      loading: unref(isApproveLoading),
      disable: !unref(permissions).products.approve,
      onClick: confirmApproveToggleStatus,
    };
  });

  return {
    approveButton,
  };
}
